import React from "react";
import { WorkProjectShell } from "./WorkProjectShell";
import {
  WorkSplitRow,
  WorkMediaFrame,
  WorkTextStack,
  WorkSectionHeading,
  ConcludeContainer,
} from "./styles";
import { ProjectDetails } from "../../../DesignSystem/ProjectDetails";

export default function StolpersteinNRW() {
  const ProjectBG = require("../../../../assets/videos/stolperstein-nrw/banner.jpg");
  const T1 = require("../../../../assets/videos/stolperstein-nrw/t1.png");
  const T2 = require("../../../../assets/videos/stolperstein-nrw/t2.png");

  return (
    <WorkProjectShell
      posterSrc={ProjectBG}
      title="Stolpersteine NRW — remembrance in AR"
      lead={
        <p>
          Digital service honoring Holocaust victims in North Rhine-Westphalia:
          research, mobile app, and AR experiences—Grimme Online Award 2023
          (Knowledge & Education).
        </p>
      }
    >
      <WorkSplitRow>
        <WorkMediaFrame>
          <video controls poster={T1}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/stolperstein-nrw/1_Stolperstein.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Interactive stumbling blocks</WorkSectionHeading>
          <p>
            Navigate to memorial stones across NRW and read the stories of
            those commemorated at each site.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow $reverse>
        <WorkMediaFrame>
          <video controls poster={T2}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/stolperstein-nrw/2_Stolperstein.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Augmented reality</WorkSectionHeading>
          <p>
            Prototypes explored spatial anchors and rich AR: historical
            imagery, biographies, audio, and symbolic gestures such as virtual
            candles.
          </p>
          <WorkSectionHeading>Impact</WorkSectionHeading>
          <p>
            Strong adoption after launch underscores the importance of accessible
            remembrance and education.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <ConcludeContainer>
        <p>
          Stolpersteine NRW combines technology and scholarship so audiences can
          engage empathetically with history in public space and at home.
        </p>
      </ConcludeContainer>

      <ProjectDetails
        details={[
          { label: "Project Name", value: "Stolperstein NRW" },
          { label: "Period", value: "09.2020 - 07.2021" },
          { label: "Client", value: "WDR" },
          { label: "Engine & Tools", value: "Unity, AR Foundation, C#" },
          { label: "Platform", value: "Mobile" },
          { label: "Company", value: "Radiusmedia KG" },
          { label: "Tags", value: "AR" },
        ]}
      />
    </WorkProjectShell>
  );
}
